module.exports = __webpack_public_path__ + "static/media/bancontact.1c297850.svg";